<div class="assistant-banner-content-message-container">
  <div
    class="text"
    *ngIf="message.html"
    [innerHtml]="message.html"
    [ngClass]="message.cssClass"
  ></div>
  <div *ngIf="message.image">
    <img
      class="image"
      [src]="message.image"
      imgErrLog
    />
  </div>
  <div *ngIf="message.radioButtons">
    <mat-radio-group
      class="radio-group"
      (change)="onRadioChange($event)"
    >
      <mat-radio-button
        class="radio"
        [value]="rb.value"
        *ngFor="let rb of message.radioButtons"
        disableRipple
        >{{ rb.text }}</mat-radio-button
      >
    </mat-radio-group>
  </div>
  <ng-container *ngIf="message.button">
    <button
      merriNoFocusLink
      (click)="onActionBtnClick(message.button)"
      class="button blank-button"
      [style.color]="message.button.color"
      [style.background-color]="message.button.backColor"
      [class.inline]="message.button.inline"
      [class.padded]="message.button.padded"
      [class.font-family-bold]="message.button.bold"
    >
      {{ message.button.text }}
    </button>
  </ng-container>
</div>
